import common from '@/common';
import router from '@/router';

export const DELETE_ACCOUNT_LOGIN_PROMPT = '請先登入需要刪除的帳戶';

export const isDeleteAccountRouteLink = (href: string) => {
  try {
    const url = new URL(href, window.location.origin);
    return url.pathname === '/deleteAccount';
  } catch (error) {
    return false;
  }
};

export const handleAboutContentLinkClick = async (event: MouseEvent) => {
  const target = event.target as Element | null;
  const link = target && target.closest('a');
  const href = link && (link.getAttribute('href') || (link as HTMLAnchorElement).href);

  if (!href || !isDeleteAccountRouteLink(href)) {
    return false;
  }

  event.preventDefault();

  const token = await common.getToken();
  if (!token) {
    common.showConfirm(
      DELETE_ACCOUNT_LOGIN_PROMPT,
      '提示',
      function () {
        return;
      },
      undefined,
      '確定',
      false
    );
    return true;
  }

  router.push('/deleteAccount');
  return true;
};
